import { preloaderWithBg } from "helpers/sf_constants";
import React from "react";

const SfLoadingSpinner = () => {
    return (
        <div id=""> 
            <div id="status">
                <img src={preloaderWithBg} alt="logo" height="80" />
            </div>
        </div>
    )
}

export default SfLoadingSpinner;